<script setup lang="ts">
import './assets/style.scss'
import { ref, watch } from 'vue'
import WInventoryMapinfoSelected from './WInventoryMapinfoSelected.vue'
import { useInventoryMapInfo } from '../model/model.ts'
import { VPreloader } from '@/shared/ui'
import WInventoryMapInfoItem from '@/widgets/InventoryMapInfo/ui/WInventoryMapInfoItem.vue'
import { InventObjectReplaceForm } from '@/features/Inventory/ObjectReplace'
import { WInventoryLEPModal } from '@/widgets'

const selected = defineModel<number[]>({ default: [] })

const emits = defineEmits(['updateCoords', 'mapObjectFocused'])
const openPanels = ref<number[]>([0])

/* Подгружаем данные с сервера */
const model = useInventoryMapInfo()

const { isFetching } = model.loadData(selected)

/* Очищаем загруженные данные при сбросе выбранных элементов */
watch(
  selected,
  () => {
    if (!selected.value?.length) model.data = []

    /* Смотрим за количеством элементов и открываем первый элемент */
    if (selected.value?.length === 1) {
      openPanels.value = [1]
    } else {
      openPanels.value = []
    }
  },
  { deep: true, immediate: true },
)

/**
 * Обработка выбранных новых элементов
 * @param ids
 */
const updateSelectedHandler = (ids: number[]) => {
  selected.value = ids
}

/**
 * Функция очистки данных выбранных элементов
 */
const clearHandler = () => {
  selected.value = []
  model.data = []
}

/**
 * Функция выбора всех дочерних элементов выбранных элементов
 */
const allSelectHandler = () => {
  if (!model.data) return

  const addSelected = model.data.flatMap((item) => item.stats.object_ids)
  selected.value = [...new Set([...selected.value, ...addSelected])]
}

/**
 * Функция удаления элемента из выбранных
 */
const deleteFromSelectedHandler = (id: number) => {
  selected.value = selected.value.filter((item) => item !== id)
}

/**
 * Обработчик центрирования / подгонки карты по геометрии объекта
 */
const mapObjectFocusedHandler = (coordinates: number[][]) => {
  emits('mapObjectFocused', coordinates)
}
</script>

<template>
  <div v-if="selected.length" class="w-invent-map-info">
    <VExpansionPanels v-model="openPanels" multiple>
      <WInventoryMapinfoSelected
        :items="selected"
        @clear="clearHandler"
        @allSelect="allSelectHandler"
      />

      <VPreloader v-if="isFetching" :wrapper-height="300" />

      <template v-else>
        <WInventoryMapInfoItem
          v-for="item in model.data"
          :key="item.id"
          :item
          @update-selected="updateSelectedHandler"
          @update-coords="emits('updateCoords')"
          @delete-from-selected="deleteFromSelectedHandler"
          @map-object-focused="mapObjectFocusedHandler"
        />
      </template>
    </VExpansionPanels>
  </div>

  <InventObjectReplaceForm />
  <WInventoryLEPModal />
</template>
